import React from 'react';
import { Grid } from 'react-flexbox-grid';
import { Placeholder, Text, RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import AssetExplorerStandalone from '@component/AssetExplorerStandalone';
import { findTranslation } from '../../findTranslation';

const query = `
query Query($q: String, $top: Int, $skip: Int, $language: String, $fields: String, $filters: [FiltersInput]) {
  searchWebdam(q: $q, top: $top, skip: $skip, language: $language, fields: $fields, filters: $filters) {    
    results {
      document {
        Id
        Filename
        Filetype
        Filesize
        Type
        MediaUrl
        AudioUrl
        Status
        LogoJpgUrl
        LogoPngUrl
        Language
        BrandcenterType
        AssetType
        AssetSubType
        OurCauses
        Campaign
        Keyword
        ThumbnailUrl
        RelatedAssetIds
        ChiliTemplateId
        Transcript
        DirectDownloadLink
        DirectLink
        EmbedCode
        EN_Title
        DE_Title
        ES_Title
        FR_Title
        IT_Title
        JA_Title
        KO_Title
        PT_Title
        ZH_Title
        EN_Description
        DE_Description
        ES_Description
        FR_Description
        IT_Description
        JA_Description
        KO_Description
        PT_Description
        ZH_Description
        EN_WhenToUse
        DE_WhenToUse
        ES_WhenToUse
        FR_WhenToUse
        IT_WhenToUse
        JA_WhenToUse
        KO_WhenToUse
        PT_WhenToUse
        ZH_WhenToUse
        DateCreated
        DateModified
        IsDeleted
        RelatedAssets
      }
      score
    }
  }
}      
`;

const AssetExplorerStandaloneComponent = (props) => {
  //get UI translations
  const translationManagerItemId = 'c8400712-1344-4f16-8b31-d8a270094e9d';
  const translationManagerItem = props.fields?.children?.find((e) => e.id === translationManagerItemId);
  const assetExplorerUiTranslationsItem = translationManagerItem?.fields?.assetExplorerUiTranslations?.fields;

  //get Facet translations
  const handleFindFacetTranslation = (key, value) => {
    return findTranslation(translationManagerItem, key, value);
  };

  return (
    <>
      <div className="gray-bg asset-page">
        <Grid>
          <AssetExplorerStandalone
            assetLanguageLabel={assetExplorerUiTranslationsItem?.assetLanguageLabel?.value}
            chooseFileTypeLabel={assetExplorerUiTranslationsItem?.chooseFileTypeLabel?.vallue}
            copiedLabel={assetExplorerUiTranslationsItem?.copiedLabel?.value}
            copyLabel={assetExplorerUiTranslationsItem?.copyLabel?.value}
            createButtonLabel={assetExplorerUiTranslationsItem?.createButtonLabel?.value}
            dateCreatedLabel={assetExplorerUiTranslationsItem?.dateCreatedLabel?.value} //todo do we still need this?
            downloadButtonLabel={assetExplorerUiTranslationsItem?.downloadButtonLabel?.value}
            embedLabel={assetExplorerUiTranslationsItem?.embedLabel?.value}
            fallbackImage={assetExplorerUiTranslationsItem?.fallbackImage?.value?.src}
            fileNameLabel={assetExplorerUiTranslationsItem?.fileNameLabel?.value}
            fileSizeLabel={assetExplorerUiTranslationsItem?.fileSizeLabel?.value}
            fileTypeLabel={assetExplorerUiTranslationsItem?.fileTypeLabel?.value}
            findTranslation={handleFindFacetTranslation}
            gigabyteLabel={assetExplorerUiTranslationsItem?.gigabyteLabel?.value}
            graphqlApiUri={props.fields.graphqlapiuri}
            graphqlQuery={query}
            gridLoadErrorText={assetExplorerUiTranslationsItem?.gridLoadErrorText?.value}
            kilobyteLabel={assetExplorerUiTranslationsItem?.kilobyteLabel?.value}
            megabyteLabel={assetExplorerUiTranslationsItem?.megabyteLabel?.value}
            modalNoteLabel={assetExplorerUiTranslationsItem?.modalNoteLabel?.value}
            modalNoteText={assetExplorerUiTranslationsItem?.modalNoteText?.value}
            notFoundText={assetExplorerUiTranslationsItem?.assetNotFound?.value}
            placeholderSelectText={assetExplorerUiTranslationsItem?.placeholderSelectText?.value} //todo do we still need this?
            relatedFilesLabel={assetExplorerUiTranslationsItem?.relatedFilesLabel?.value}
            shareLabel={assetExplorerUiTranslationsItem?.shareLabel?.value}
            shareLinkLabel={assetExplorerUiTranslationsItem?.shareLinkLabel?.value}
            shareUrl={props.fields.assetexplorersharepage}
            templateCreateLink={props.fields?.templateCreateLink?.value}
            termsOfUseDownloads={assetExplorerUiTranslationsItem?.termsOfUseDownloads?.value}
            termsOfUseTemplates={assetExplorerUiTranslationsItem?.termsOfUseTemplates?.value}
            viewDetailsLabel={assetExplorerUiTranslationsItem?.viewDetailsLabel?.value}
            whenToUseLabel={assetExplorerUiTranslationsItem?.whenToUseLabel?.value}
          />
        </Grid>
      </div>
    </>
  );
};
export default withSitecoreContext()(AssetExplorerStandaloneComponent);
